import { useEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import yongyuanLogo from "../../image/yongyuan.png";
import { useLocale } from "../../i18n/LocaleContext";
import {
  getLanguageNativeName,
  SUPPORTED_LANGUAGES,
} from "../../i18n/languages";
import { localizePath } from "../../i18n/routing";
import { useLocalePath } from "../../i18n/useLocalePath";
import "./index.css";

function Header() {
  const { language, t, updateLocale } = useLocale();
  const localePath = useLocalePath();
  const navigate = useNavigate();
  const location = useLocation();
  const [openPanel, setOpenPanel] = useState(false);
  const [draftLanguage, setDraftLanguage] = useState(language);
  const localeRef = useRef(null);

  const languageLabel = getLanguageNativeName(language);

  useEffect(() => {
    setDraftLanguage(language);
  }, [language]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (localeRef.current && !localeRef.current.contains(event.target)) {
        setOpenPanel(false);
      }
    };
    const handleEscape = (event) => {
      if (event.key === "Escape") setOpenPanel(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  const applyLanguage = (nextLanguage) => {
    setDraftLanguage(nextLanguage);
    updateLocale({ language: nextLanguage, preferenceSource: "manual" });
    const nextPath = localizePath(location.pathname, nextLanguage);
    navigate(nextPath, { replace: true });
  };

  const saveLanguage = () => {
    applyLanguage(draftLanguage);
    setOpenPanel(false);
  };

  return (
    <header className="site-header">
      <div className="site-header-waves" aria-hidden="true" />
      <div className="site-header-container site-header-nav-wrap">
        <div className="site-header-brand">
          <Link to={localePath("/")} className="site-header-brand-link">
            <img src={yongyuanLogo} alt="YONGYUAN" className="site-header-logo" />
          </Link>
        </div>

        <nav className="site-header-nav" aria-label="Main">
          <NavLink to={localePath("/")} end>
            {t("navHome")}
          </NavLink>
          <NavLink to={localePath("/products")}>{t("navProducts")}</NavLink>
          <NavLink to={localePath("/cases")}>{t("navCases")}</NavLink>
          <NavLink to={localePath("/about")}>{t("navAbout")}</NavLink>
        </nav>

        <div className="site-header-locale" ref={localeRef}>
          <button
            type="button"
            className={`locale-trigger ${openPanel ? "open" : ""}`}
            onClick={() => setOpenPanel((prev) => !prev)}
            aria-label={t("language")}
          >
            <span className="locale-globe" aria-hidden="true">
              🌐
            </span>
            <span className="locale-trigger-value">
              <span className="locale-trigger-lang">{languageLabel}</span>
            </span>
          </button>

          {openPanel && (
            <div className="locale-popover" role="dialog">
              <div className="locale-popover-caret" />
              <h3>{t("localeLangTitle")}</h3>
              <p className="locale-popover-desc">{t("localeLangDesc")}</p>

              <label className="locale-field">
                <span>{t("language")}</span>
                <select
                  className="locale-select"
                  value={draftLanguage}
                  onChange={(event) => applyLanguage(event.target.value)}
                >
                  {SUPPORTED_LANGUAGES.map((item) => (
                    <option key={item.code} value={item.code}>
                      {item.nativeName}
                    </option>
                  ))}
                </select>
              </label>

              <button
                type="button"
                className="locale-btn-primary"
                onClick={saveLanguage}
              >
                {t("save")}
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
